import { useCallback, useState } from 'react';
import { CalendarService } from '@services/requests/housien-services/CalendarService';

export type UseGoogleDisconnectReturn = {
  disconnect: () => Promise<void>;
  isDisconnecting: boolean;
  error: boolean;
};

/**
 * Revokes Google Calendar connection for the agency user.
 */
export const useGoogleDisconnect = (agencyId: string): UseGoogleDisconnectReturn => {
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [error, setError] = useState(false);

  const disconnect = useCallback(async () => {
    setError(false);
    setIsDisconnecting(true);
    try {
      await CalendarService.disconnectGoogle(agencyId);
    } catch {
      setError(true);
      throw new Error('google_disconnect_failed');
    } finally {
      setIsDisconnecting(false);
    }
  }, [agencyId]);

  return { disconnect, isDisconnecting, error };
};
